import { format, isValid, parseISO } from "date-fns";

import { captureMessage } from "@/modules/shared/utils/sentry";

export const formatSurveySessionDate = (sessionDate: string) => {
  const parsedSessionDate = parseISO(sessionDate);

  if (!isValid(parsedSessionDate)) {
    captureMessage(
      `Survey session date failed to parse: ${sessionDate}`,
      "warning",
    );

    return sessionDate;
  }

  return format(parsedSessionDate, "EEEE, MMMM d");
};
